import realEstateImg from "../images/RealEstate.png";
import oneStopImg from "../images/onestop.png";
import skyShareImg from "../images/skyshare.png";
import oniFood from "../images/oniFood.png";
import webScrapper from "../images/webScrapper.png";
import BlogApp from "../images/BlogApp.png";
import ArestroImg from "../images/Arestro.jpg";
import sadiqLogo from "../images/sadiq.png";
import eeklinLogo from "../images/eeklin.svg";
import pearlsLogo from "../images/pearls.svg";
import coderatoryLogo from "../images/coderatory.svg";
import xpertLogo from "../images/xpert.svg";
import leadgenImg from "../images/leadgen.svg";
import payflowImg from "../images/payflow.svg";
import marketingAiImg from "../images/marketingai.svg";

const icon = (name) => `https://skillicons.dev/icons?i=${name}`;

export const Bio = {
  name: "Aliza Khan",
  roles: [
    "AI Full Stack Software Engineer",
    "MERN Stack Developer",
    "Frontend Developer",
    "Backend Developer",
    "Software Engineer",
  ],
  description:
    "Full Stack Software Engineer with production experience building scalable web platforms, AI-powered products, and marketplace systems. Currently at Sadiq.ai, shipping full-stack features with React.js, Node.js, and cloud deployments on GCP. Previously delivered applications for international clients across the US and Canada, with a focus on clean architecture, automation, and measurable product impact.",
  github: "https://github.com/AlizaKhan3",
  resume: "https://drive.google.com/file/d/1k6PaOcE4a5sLTfH1XRl3Z-7AozbLbOXs/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/aliza-khan3/",
  upwork: "https://www.upwork.com/freelancers/alizakhan?mp_source=share",
  email: "alizaadi2@gmail.com",
  phone: "+92 321 8111001",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "React.js", image: icon("react") },
      { name: "Next.js", image: icon("nextjs") },
      { name: "React Native", image: icon("react") },
      { name: "TypeScript", image: icon("ts") },
      { name: "JavaScript", image: icon("js") },
      { name: "Three.js", image: icon("threejs") },
      { name: "Redux", image: icon("redux") },
      { name: "React Query", image: icon("react") },
      { name: "HTML", image: icon("html") },
      { name: "CSS", image: icon("css") },
      { name: "Tailwind CSS", image: icon("tailwind") },
      { name: "Bootstrap", image: icon("bootstrap") },
      { name: "Material UI", image: icon("materialui") },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Node.js", image: icon("nodejs") },
      { name: "Express.js", image: icon("express") },
      { name: "Python", image: icon("py") },
      { name: "FastAPI", image: icon("py") },
      { name: "REST APIs", image: icon("nodejs") },
      { name: "MongoDB", image: icon("mongodb") },
      { name: "PostgreSQL", image: icon("postgres") },
      { name: "MySQL", image: icon("mysql") },
      { name: "Redis", image: icon("redis") },
      { name: "Firebase", image: icon("firebase") },
      { name: "Prisma", image: icon("prisma") },
    ],
  },
  {
    title: "Cloud & DevOps",
    skills: [
      { name: "AWS", image: icon("aws") },
      { name: "GCP", image: icon("gcp") },
      { name: "Docker", image: icon("docker") },
      { name: "Nginx", image: icon("nginx") },
      { name: "Azure", image: icon("azure") },
    ],
  },
  {
    title: "AI Integrations",
    skills: [
      { name: "OpenAI", image: icon("py") },
      { name: "Anthropic", image: icon("py") },
      { name: "Gemini", image: icon("gcp") },
      { name: "LangChain", image: icon("py") },
      { name: "LangGraph", image: icon("py") },
      { name: "RAG", image: icon("py") },
      { name: "Playwright", image: icon("js") },
      { name: "VAPI AI", image: icon("nodejs") },
    ],
  },
  {
    title: "Tools",
    skills: [
      { name: "Git", image: icon("git") },
      { name: "GitHub", image: icon("github") },
      { name: "Postman", image: icon("postman") },
      { name: "Figma", image: icon("figma") },
      { name: "VS Code", image: icon("vscode") },
      { name: "Vercel", image: icon("vercel") },
      { name: "Render", image: icon("heroku") },
      { name: "Netlify", image: icon("netlify") },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: sadiqLogo,
    role: "Full Stack Software Engineer",
    company: "Sadiq.ai",
    date: "December 2025 - Present",
    desc: "Delivered scalable full-stack marketplace features that improved user engagement by 20% using React.js and Node.js. Deployed applications on GCP and built GitHub webhook integrations to improve reliability and automation. Built self-service Admin Panel tools for promotions, popups, theme management, and Role-Based Access Control (RBAC). Also shipped an end-to-end blogs management system and a size-recommendation flow now live across multiple e-commerce sites.",
    skills: [
      "React.js",
      "Node.js",
      "TypeScript",
      "Next.js",
      "MongoDB",
      "GCP",
      "GitHub Webhooks",
      "RBAC",
    ],
  },
  {
    id: 1,
    img: eeklinLogo,
    role: "Junior Software Engineer",
    company: "Eeklin",
    date: "June 2025 - December 2025",
    desc: "Built, scaled, and maintained production applications with large codebases for international clients across the US and Canada. Led development initiatives, conducted technical interviews, and delivered web solutions for global teams. Engineered and deployed full-stack applications using React.js, Node.js/Express.js, MongoDB, GCP, Azure, and GitHub webhooks.",
    skills: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "GCP",
      "Azure",
      "GitHub Webhooks",
    ],
  },
  {
    id: 2,
    img: pearlsLogo,
    role: "MERN Stack Developer Intern — Remote",
    company: "10Pearls",
    date: "September 2025 - October 2025",
    desc: "Worked on individual full-stack projects from scratch using React.js, Express.js, Node.js, MongoDB, React Native, and Tailwind CSS, with a focus on clean architecture and production-ready delivery.",
    skills: [
      "JavaScript",
      "React.js",
      "TypeScript",
      "Next.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "React Native",
      "Tailwind CSS",
    ],
  },
  {
    id: 3,
    img: coderatoryLogo,
    role: "MERN Stack Developer Intern — Onsite",
    company: "Coderatory",
    date: "March 2025 - May 2025",
    desc: "Worked on client projects using React.js, Node.js, Express.js, and MongoDB with a strong focus on performance. Built and maintained a cross-platform sports mobile application in React Native, developing responsive UI components and scalable features with Tailwind CSS. Also contributed to a community platform and a web scraper using Next.js, TypeScript, MongoDB, and Playwright.",
    skills: [
      "React.js",
      "React Native",
      "TypeScript",
      "Next.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "Tailwind CSS",
      "Playwright",
    ],
  },
  {
    id: 4,
    img: xpertLogo,
    role: "Web Developer Trainee (React & React Native) — Onsite",
    company: "360Xpert Solutions",
    date: "September 2024 - January 2025",
    desc: "Built the complete frontend of a real estate website and improved user experience across projects by resolving bugs and reducing load time by 40%.",
    skills: [
      "React.js",
      "React Native",
      "Next.js",
      "Tailwind CSS",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "data:image/png;base64,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",
    school: "University of Karachi, UBIT",
    date: "2022 - 2026",
    grade: "3.61 CGPA / 4.0",
    desc: "Bachelor of Science in Computer Science at UBIT, University of Karachi. Coursework includes Artificial Intelligence, Data Structures & Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Bachelor of Science — BS, Computer Science",
  },
  {
    id: 1,
    img: "data:image/jpeg;base64,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",
    school: "Government Degree Girls College Shaikh Zayed, Karachi",
    date: "2020 - 2022",
    grade: "A+",
    desc: "Completed Intermediate (Pre-Engineering) with an A+ grade.",
    degree: "Intermediate, Pre-Engineering",
  },
];

export const achievements = [
  {
    id: 0,
    title: "Winner — AI Poster Competition",
    org: "University of Karachi",
    year: "2025",
    desc: "First place for an AI-focused research poster presented at the University of Karachi.",
  },
  {
    id: 1,
    title: "Runner Up — AI Hackathon",
    org: "Techfest'26",
    year: "2026",
    desc: "Placed runner-up at TechFest for an AI product built under hackathon constraints.",
  },
  {
    id: 2,
    title: "Gold Medalist — Active Participation",
    org: "University of Karachi",
    year: "2025",
    desc: "Recognized with a gold medal for active academic and extracurricular participation.",
  },
];

export const projects = [
  {
    id: 0,
    title: "LeadGen — Lead Finder Agent",
    date: "2026",
    description:
      "Engineered an AI-powered lead discovery agent using Google Maps, web scraping, and LLM-based analysis. Automated evidence-based lead qualification and CSV report generation with Playwright and Groq.",
    image: leadgenImg,
    tags: ["Python", "Groq LLM", "Streamlit", "Playwright"],
    category: ["AI", "Website", "All"],
    github: "https://github.com/AlizaKhan3",
  },
  {
    id: 1,
    title: "PayFlow — Invoice & Payment Automation",
    date: "2026",
    description:
      "Built an automated invoice and payment reminder system to help small businesses track unpaid invoices and reduce manual follow-ups. Implemented scheduled reminder workflows with BullMQ and Redis, plus WhatsApp notifications via Twilio.",
    image: payflowImg,
    tags: ["MERN", "TypeScript", "Redis", "BullMQ", "Docker", "Twilio"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/Invoice-and-Payment-Automation",
  },
  {
    id: 2,
    title: "Marketing AI — Personalized Strategy Engine",
    date: "2026",
    description:
      "Designed a 3-agent AI system for user behavior analysis, marketing strategy selection, and personalized ad generation. Integrated Google Gemini with FastAPI and SSE for real-time recommendations and campaign insights.",
    image: marketingAiImg,
    tags: ["Next.js", "FastAPI", "Python", "Google Gemini", "SSE"],
    category: ["AI", "Website", "All"],
    github: "https://github.com/AlizaKhan3/Personalized-Marketing-Strategist",
  },
  {
    id: 3,
    title: "Blog App",
    date: "July 2025",
    description:
      "Built a full-stack blog platform with Next.js, TypeScript, and Firebase, including authenticated publishing workflows and a polished reading experience.",
    image: BlogApp,
    tags: ["Next.js", "TypeScript", "Radix UI", "jose-jwt", "Firebase"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/NextJS-BlogApp/tree/next-js/day-39",
    webapp: "https://next-js-blog-app-six-gamma.vercel.app/",
  },
  {
    id: 4,
    title: "Web Scraper",
    date: "August 2025",
    description:
      "Built a dynamic web scraper with Next.js, TypeScript, Playwright, Cheerio, and PapaParse that extracts data from any URL, with HTML tag-based scraping and mouse selector mode.",
    image: webScrapper,
    tags: ["Next.js", "TypeScript", "Playwright", "PapaParse", "Cheerio", "Tailwind CSS"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/Web-Scrapper-Coderatory",
    webapp: "https://web-scrapper-zeta.vercel.app/",
  },
  {
    id: 5,
    title: "Real Estate Website",
    date: "June 2025",
    description:
      "Full-stack real estate platform with React.js, Node.js, Express.js, and MongoDB, including secure authentication and an admin-only property management dashboard.",
    image: realEstateImg,
    tags: ["React", "MongoDB", "Express.js", "Node.js", "JWT", "Tailwind CSS"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/Real-Estate",
    webapp: "https://real-estate-six-theta-68.vercel.app/",
  },
  {
    id: 6,
    title: "Sky Share",
    date: "Nov 2024",
    description:
      "A lightweight React and Firebase app for seamless text and file sharing across devices, inspired by AirForShare.",
    image: skyShareImg,
    tags: ["React.js", "Firebase", "JavaScript", "Tailwind CSS"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/SkyShare",
    webapp: "https://skyshare.surge.sh/",
  },
  {
    id: 7,
    title: "One Stop Shop",
    date: "July 2025",
    description:
      "Responsive e-commerce web app with React, Tailwind CSS, and Redux, featuring dark/light theme support and Stripe checkout via Express and Axios.",
    image: oneStopImg,
    tags: ["React", "Redux", "Stripe", "REST APIs", "Tailwind CSS"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/Ecommerce-React",
    webapp: "https://onestoppk.netlify.app/",
  },
  {
    id: 8,
    title: "ARestro",
    date: "September 2025",
    description:
      "Full-stack React Native app with Node.js, Express.js, and MongoDB, enabling users to order from multiple restaurants, track riders in real time, and submit reviews.",
    image: ArestroImg,
    tags: ["React Native", "MongoDB", "REST APIs", "Express", "Node.js"],
    category: ["Mobile App", "All"],
    github: "https://github.com/AlizaKhan3/Arestro",
  },
  {
    id: 9,
    title: "Oni Food",
    date: "January 2024",
    description:
      "Responsive food delivery platform built with JavaScript, HTML, CSS, and Firebase Firestore, featuring restaurant browsing, order tracking, and an admin dashboard.",
    image: oniFood,
    tags: ["JavaScript", "HTML", "CSS", "Bootstrap", "Firebase"],
    category: ["Website", "All"],
    github: "https://github.com/AlizaKhan3/Food-Delivery-Website",
    webapp: "https://onlinefood-7799a.web.app/",
  },
];
